import { render, staticRenderFns } from "./WillRoles.vue?vue&type=template&id=b4b87aaa"
import script from "./WillRoles.vue?vue&type=script&lang=js"
export * from "./WillRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports